import React from 'react';
import { connect } from 'react-redux';
import ProgressBar from 'components/ProgressBar';
import NotificationBar from 'components/Notification/NotificationBar';
import BillingReminderVersionTwo from 'components/BillingReminderVersionTwo';
import BillingReminder from 'components/BillingReminder';
import Sidebar from 'components/Sidebar';
import moment from 'moment';
import {
  isFullSiteMode,
  setResponsiveMode,
  setMobileMeta,
} from 'utils/fullSite';
import Nav from 'components/Nav';
import FullSiteSwitchBanner from 'components/FullSiteSwitchBanner';
import withFeatureFlags from 'hocs/withFeatureFlags';
import classNames from 'classnames';
import { browserHistory } from 'react-router';
import MwebFullSiteSwitchFtue from 'components/MwebFullSiteSwitchFtue';
import {
  FTUE_MWEB_FULL_SITE_SWITCH,
  FTUE_ONBOARDING_MERCHANT,
} from 'reducers/ftue/ftueKeys';
import { fetchExperiences, completeExperience } from 'reducers/ftue/actions';
import { getInventoryFeatureFlag } from 'reducers/inventoryFeatures/actions';
import { switchToMweb as switchToMwebClevertap } from 'clevertap/mWebFullSiteSwitch';
import styles from './LayoutLoggedIn.css';
import isExperienceComplete from '../../../selectors/isExperienceComplete';

class LayoutLoggedIn extends React.Component {
  render() {
    const hideSidebarRoute = ['kyb', 'business-info'];
    const currentPath = this._getClassByPath();
    const showSidebar = !hideSidebarRoute.includes(currentPath);
    const {
      data,
      location,
      children,
      enableMwebFullSiteSwitch,
      switchViewFtueComplete,
      onBoardingFtueComplete,
    } = this.props;
    const { pathname } = location;
    const { moka, notification, subscriptionExpired, kybStep } = data;
    const { user, showLoadingSpinner, loggedIn } = moka;
    const { business } = user;
    let isRegistrationComplete = business.is_registration_complete;

    if (isRegistrationComplete === null) {
      isRegistrationComplete = true;
    }

    const shouldShowBillingReminder = this.showBillingReminder(
      user,
      subscriptionExpired
    );

    const showBillingReminderClass = shouldShowBillingReminder
      ? 'show-billing-reminder'
      : '';

    const showSwitchBanner = enableMwebFullSiteSwitch && isFullSiteMode();
    const displaySwitchFtue =
      showSwitchBanner && !switchViewFtueComplete && onBoardingFtueComplete;

    return (
      <div>
        {showSwitchBanner && (
          <FullSiteSwitchBanner
            onClickSwitchButton={this.handleSwitchToMobileSite}
          />
        )}

        {displaySwitchFtue && (
          <MwebFullSiteSwitchFtue
            onCompletion={this.handleCompletionSwitchViewsFtue}
          />
        )}

        {this.showBillingReminder(user, subscriptionExpired) && (
          <div className="visible-md visible-lg">
            <BillingReminderVersionTwo
              user={moka.user}
              subscriptionExpired={subscriptionExpired}
            />
          </div>
        )}
        <div className="clear" />
        <div id="wrapper" className={`toggled ${showBillingReminderClass}`}>
          {showLoadingSpinner ? (
            <div id="loading-container" className="mk-loading-container">
              <div className="center-spinner moka-spinner" />
            </div>
          ) : (
            <ProgressBar updateTime={500} currentPath={pathname} />
          )}

          {!showSidebar && (
            <header className="mk-head-bar">
              {!showSidebar && (
                <Nav loggedIn={loggedIn} user={user} location={location} />
              )}
              {!showSidebar && (
                <NotificationBar
                  notification={notification}
                  location={location}
                />
              )}
            </header>
          )}

          {showSidebar && (
            <Sidebar
              location={location}
              showSwitchBanner={showSwitchBanner}
              showBillingReminder={this.showBillingReminder(
                user,
                subscriptionExpired
              )}
            />
          )}
          <div
            id="page-content-wrapper"
            className={classNames(
              `wrapper${this._getFullClassByPath()}`,
              `wrapper-${kybStep}`,
              showSwitchBanner && styles.wrapperWithBanner,
              showSwitchBanner &&
                shouldShowBillingReminder &&
                styles.wrapperFullSiteWithReminder
            )}
          >
            <div className="container content-sidebar">
              <div className="row">
                <div
                  className={`${
                    showSidebar
                      ? 'col-md-10 col-md-offset-2 fixed-content-sidebar'
                      : 'col-md-12'
                  }`}
                >
                  {showSidebar && (
                    <NotificationBar
                      notification={notification}
                      location={location}
                      sidebarNotification
                    />
                  )}
                  <div className="col-md-12 app-container">
                    <div
                      className={`full-height section-content ${this._getClassByPath()}`}
                    >
                      {!pathname.startsWith('/dashboard') && (
                        <div className="visible-sm visible-xs reminder-responsive">
                          <BillingReminder
                            user={user}
                            subscriptionExpired={subscriptionExpired}
                          />
                        </div>
                      )}
                      <div className="container-full-nosub box-content-container">
                        {children}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _getClassByPath() {
    const { location } = this.props;
    const classbyPath = location.pathname.split('/');
    if (
      location.pathname.startsWith('/table-management/map') &&
      isFullSiteMode()
    ) {
      return 'map-full-site';
    }
    return classbyPath[classbyPath.length - 1];
  }

  _getFullClassByPath() {
    const { location } = this.props;
    const classbyPath = location.pathname.split('/');
    return classbyPath.join('-');
  }

  showBillingReminder = (user, subscriptionExpired) => {
    const daysLeft = this.calculateDaysLeft(user);
    let reminder = false;

    if (this.isExpired(user, subscriptionExpired)) {
      reminder = true;
    } else if (this.isTrial(user) && !this.isAlreadySubscribed(user)) {
      reminder = true;
    } else if (!this.isTrial(user) && daysLeft <= 14) {
      reminder = true;
    }
    return reminder;
  };

  isExpired = (user, subscriptionExpired) => {
    const expired = this.calculateDaysLeft(user) <= 0;

    if (expired) {
      subscriptionExpired.expired = true;
    }

    return expired;
  };

  calculateDaysLeft = user => {
    const calculatedDaysLeft = Math.ceil(
      moment(user.business.expired_at).diff(moment(), 'hours') / 24
    );
    const currentDaysInMonth = moment().daysInMonth();
    let daysLeft = 0;
    if (calculatedDaysLeft > currentDaysInMonth) {
      daysLeft = currentDaysInMonth;
    } else {
      daysLeft = calculatedDaysLeft;
    }
    return daysLeft;
  };

  isTrial = user => {
    return user.business.is_trial;
  };

  isAlreadySubscribed = user => {
    return user.already_subscribed;
  };

  handleSwitchToMobileSite = () => {
    // Enable responsive view
    setMobileMeta();
    // Keep user in mobile site when refreshing page
    setResponsiveMode(true);

    // Redirect to default landing page
    browserHistory.push('/');

    switchToMwebClevertap();
  };

  componentDidMount() {
    const {
      fetchExperiences,
      enableMwebFullSiteSwitch,
      ecommerceAttributes,
      getInventoryFeatureFlag,
    } = this.props;

    if (enableMwebFullSiteSwitch) {
      fetchExperiences();
    }
    if (ecommerceAttributes) {
      getInventoryFeatureFlag();
    }
  }

  handleCompletionSwitchViewsFtue = () => {
    const { completeExperience } = this.props;
    completeExperience(FTUE_MWEB_FULL_SITE_SWITCH);
  };
}

function mapStateToProps(state) {
  return {
    data: {
      moka: state.moka,
      subscriptionExpired: state.subscriptionExpired,
      notification: state.notification,
      kybStep: state.kybForm.step,
    },
    switchViewFtueComplete: isExperienceComplete(
      state,
      FTUE_MWEB_FULL_SITE_SWITCH
    ),
    onBoardingFtueComplete: isExperienceComplete(
      state,
      FTUE_ONBOARDING_MERCHANT
    ),
  };
}

const mapDispatchToProps = {
  fetchExperiences,
  completeExperience,
  getInventoryFeatureFlag,
};

const mapFlagsToProps = flags => ({
  enableMwebFullSiteSwitch: flags.enableMwebFullSiteSwitch,
  businessLibraryMenu: flags.businessLibraryMenu,
  ecommerceAttributes: flags.ecommerceAttributes,
});

export default withFeatureFlags(mapFlagsToProps)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LayoutLoggedIn)
);
